import React from 'react';
import styles from './LogoutPopup.module.scss';
import { Popover } from 'antd';
import { LogoutPopupPropsEnums } from 'enums/LogoutPopupEnums';
import { ReactComponent as Logout } from 'assets/icons/logout.svg';
import { ReactComponent as Key } from 'assets/icons/key.svg';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { User } from 'models/user.model';
interface LogoutPopupProps {
  children: React.ReactNode;
  logout: () => void;
}
const LogoutPopup: React.FC<LogoutPopupProps> = ({
  children,
  logout,
}: LogoutPopupProps) => {
  const navigate = useNavigate();
  const user = localStorage.getItem('userDetails');
  let parsedUser: User;
  if (user) {
    parsedUser = JSON.parse(user);
  }
  const handleResetPasswordNavigation = () => {
    navigate(AppRoutes.SET_NEW_PASS, { state: parsedUser.email });
  };
  const content = (
    <div className={styles.contentContainer}>
      <div
        onClick={handleResetPasswordNavigation}
        className={styles.logoutContainer}>
        <Key className={styles.logoutButton} />
        <h3>{LogoutPopupPropsEnums.CHANGE_PASSWORD}</h3>
      </div>
      <div onClick={logout} className={styles.logoutContainer}>
        <Logout className={styles.logoutButton} />
        <h3>{LogoutPopupPropsEnums.LOGOUT}</h3>
      </div>
    </div>
  );
  return (
    <Popover
      overlayClassName="profilePopup"
      placement={LogoutPopupPropsEnums.RIGHT}
      title={LogoutPopupPropsEnums.EMPTY_STRING}
      content={content}
      trigger={LogoutPopupPropsEnums.CLICK_TRIGGER}>
      {children}
    </Popover>
  );
};

export default LogoutPopup;
